export default __webpack_public_path__ + "static/media/news4.0be2e1ae.jpg";